// extracted by mini-css-extract-plugin
export default {"pageContainer":"WSPage-module_pageContainer-f9SGL","breadCrumb":"WSPage-module_breadCrumb-q9RJF","link":"WSPage-module_link-EowNx"};